import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {
  public user: any = {};
  toVerifyEmail: Subject<string> = new Subject<string>();
  public status: boolean;

  constructor(private router: Router, private userDAO: UserDAO) {}

  ngOnInit() {
    this.status = false;
    this.user.roles = [2];
  }

  public enroll(userForm: any) {
    this.user = userForm.user;
    this.user.username = this.user.email;
    this.userDAO.createBrokerAsAdmin(this.user).subscribe(
      (data) => {
        this.router.navigate(['manage/admin/user/edit/' + data.id]);
      },
      () => {
        console.log('Failed to enroll user');
      },
    );
  }

  cancel() {
    this.router.navigate(['manage/admin/users']);
  }
}
